import React from 'react';
import s from './Header.scss';
import { Container, Row, Col } from 'wix-style-react';
import { ReactComponent as Logo } from '@wix/brand-resources/resources/EditorX/EditorX_logo_31x141_white.svg';
import { WithTranslation } from 'react-i18next';
import { getLink } from '../Content/links';
import { DesktopMenu, MobileMenu } from './Menus';
import { errorDataType } from '../../errorData';
import { errorMapping } from './errorsMaping';

interface HeaderProps extends WithTranslation {
  errorData: errorDataType;
}

export const Header: React.FC<HeaderProps> = ({ t, errorData }) => {
  const { errorCode } = errorData;
  const errorTemplate = errorMapping[errorCode] || errorMapping.default;

  if (!errorTemplate.showHeader) {
    return null;
  }

  return (
    <div className={s.pageHeader}>
      <Container fluid={true}>
        <Row stretchViewsVertically={true}>
          <Col span={4}>
            <div className={s.logoContainer}>
              <a href={getLink('editorX')} target="_blank">
                <Logo className={s.logo} />
              </a>
            </div>
          </Col>
          <DesktopMenu t={t} />
          <MobileMenu t={t} />
        </Row>
      </Container>
    </div>
  );
};
